import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, useTheme } from '@mui/material';
import partnershipDark from '../../../../assets/paypalPartnership/indexxPaypalForDarkMode.svg';
import partnershipLight from '../../../../assets/paypalPartnership/indexxPaypalForWhiteMode.svg';
import partnershipFirst from '../../../../assets/paypalPartnership/paypalTopBanner.svg';
import GenericButton from '../../shared/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    margin: 'auto',
    marginTop: '50px',
    maxWidth: '1280px',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: { padding: '10px' },
  },
  topBar: {
    width: '100%',
    maxWidth: '1280px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: '0 auto 10px',
    padding: '0 20px',
  },
  backLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    color: `${theme.palette.text.secondary} !important`,
    fontSize: 16,
    padding: 0,
    '&:hover': { color: `${theme.palette.text.primary} !important` },
    [theme.breakpoints.down('sm')]: { fontSize: 14 },
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
    margin: '20px 0',
  },
  imagetwo: {
    maxWidth: '525px',
    width: '100%',
    height: 'auto',
    margin: '10px 0',
  },
  welcomeText: {
    fontSize: '36px',
    marginBottom: '10px',
    fontWeight: '500',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: { fontSize: '28px' },
  },
  welcomeDescription: { marginBottom: '20px' },
  instructionsText: {
    fontSize: '24px',
    color: theme.palette.text.primary,
    margin: '20px 0',
    [theme.breakpoints.down('sm')]: { fontSize: '18px' },
  },
  cardPaymentButton: {
    display: 'inline-block',
    color: theme.palette.text.primary,
    border: `2px solid ${theme.palette.text.primary}`,
    padding: '10px 20px',
    margin: '20px 0',
    borderRadius: '8px',
  },
}));

const PaypalBridge = () => {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { payPalPaymentLink } = location.state || {};

  const handleProceedToPaypal = () => {
    if (payPalPaymentLink) {
      window.location.href = payPalPaymentLink;
    } else {
      console.error('PayPal payment link is not available');
    }
  };

  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/'); // fallback if no history
    }
  };

  return (
    <>
      {/* Top back bar */}
      <Box className={classes.topBar}>
        <button className={classes.backLink} onClick={handleGoBack}>
          <ArrowBackIcon fontSize="small" /> Go Back
        </button>
      </Box>

      {/* Main content */}
      <Box className={classes.container}>
        <img src={partnershipFirst} alt="PayPal Partnership" className={classes.image} />

        <p className={classes.welcomeText}>Welcome to our Partnership</p>
        <p className={classes.welcomeDescription}>
          Through this partnership, PayPal will manage payments for indexx
        </p>

        <img
          src={theme.palette.mode === 'dark' ? partnershipDark : partnershipLight}
          alt="Indexx x PayPal"
          className={classes.imagetwo}
        />

        <div style={{ margin: '30px 0px' }}>
          <GenericButton
            text="Pay with debit or credit card via PayPal"
            styles={{ padding: '10px 30px' }}
            onClick={handleProceedToPaypal}
          />
        </div>

        <div style={{ textAlign: 'left', width: '100%' }}>
          <p className={classes.instructionsText}>Instructions:</p>
          <p>1. Click the green button to proceed to the PayPal payment page.</p>
          <p>
            2. Please click on{' '}
            <span className={classes.cardPaymentButton}>
              Pay with a Bank Account or Credit Card
            </span>{' '}
            on the payment page to proceed with debit/credit card payment.
          </p>
        </div>
      </Box>
    </>
  );
};

export default PaypalBridge;
